"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = exports.ExtendIconDiv = exports.Shortcut = exports.HorizontalLine = exports.LabelWrapper = exports.MenuItemWrapper = exports.MenuContentWrapper = exports.MenuWrapper = exports.SubMenuWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../theme/colors");
exports.SubMenuWrapper = styled_components_1.default.div `
  position: absolute;
  left: 20px;
  top: 0;
  background: ${colors_1.WHITE};
  box-shadow: 0px 2px 6px rgba(12, 46, 16, 0.12), 0px 6px 12px rgba(12, 46, 16, 0.1);
  width: 263px;
  padding: 2px;
`;
exports.MenuWrapper = styled_components_1.default.div `
  background: ${colors_1.WHITE};
  box-shadow: 0px 2px 6px rgba(12, 46, 16, 0.12), 0px 6px 12px rgba(12, 46, 16, 0.1);
  width: 263px;
`;
exports.MenuContentWrapper = styled_components_1.default.div `
  padding: 4px 0;
`;
exports.MenuItemWrapper = styled_components_1.default.div `
  margin: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    cursor: pointer;
    background-color: ${colors_1.PALE_GREEN};
  }
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.LabelWrapper = styled_components_1.default.span `
  margin-left: 11px;
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
`;
exports.HorizontalLine = styled_components_1.default.hr `
  order: 6;
  align-self: stretch;
  flex-grow: 0;
  border: 1px solid ${colors_1.LIGHT_GREY};
  background-color: ${colors_1.LIGHT_GREY};
`;
exports.Shortcut = styled_components_1.default.div `
  margin-right: 5px;
  color: ${colors_1.GREY2};
`;
exports.ExtendIconDiv = styled_components_1.default.div `
  position: relative;
  top: 4px;
`;
exports.Item = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  margin-left: 20px;
`;
//# sourceMappingURL=ContextMenu.styles.js.map